import { render, staticRenderFns } from "./CheckboxBase.vue?vue&type=template&id=05c0875e&scoped=true&"
import script from "./CheckboxBase.vue?vue&type=script&lang=js&"
export * from "./CheckboxBase.vue?vue&type=script&lang=js&"
import style0 from "./CheckboxBase.vue?vue&type=style&index=0&id=05c0875e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05c0875e",
  null
  
)

export default component.exports